<template>
  <div id="product_content">
    <div class="product_option" v-for="(product, productIndex) in products" :key="product.ref" :id="product.ref">
      <ProductItem
        v-for="(productInfo, optionIndex) in product.options"
        :key="productInfo.title"
        :productInfo="productInfo"
        :reverse="findIndexInProducts(productIndex, optionIndex)"
      />
    </div>
  </div>
</template>

<script setup lang='ts'>
import ProductItem from "../component/ProductItem.vue";
import { useI18n } from "vue-i18n";
import { onMounted, ref, defineEmits, inject, computed } from 'vue'
import provide_key from "@/constant/provide_key";

const emits = defineEmits(["updateProductId"])
const { t } = useI18n();

const shrink: boolean | undefined = inject(provide_key.SHRINK);
const products = computed(() => [
  {
    ref: "L2L",
    options: [
      {
        title: t("product.L2L_CDU"),
        subTitle: t("product.L2L_CDU_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2L_CDU_front.png",
        thumbnailRight: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2L_CDU_back.png",
        details: [
          t("product.L2L_CDU_0"),
          t("product.L2L_CDU_1"),
          t("product.L2L_CDU_2"),
          t("product.L2L_CDU_3"),
          t("product.L2L_CDU_4"),
          t("product.L2L_CDU_5"),
        ],
      },
    ]
  },
  {
    ref: "L2A",
    options: [
      {
        title: t("product.L2A_CDU"),
        subTitle: t("product.L2A_CUD_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A1_front.png",
        thumbnailRight: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A1_back.png",
        details: [
          t("product.L2A_CDU_0"),
          t("product.L2A_CDU_1"),
          t("product.L2A_CDU_2"),
          t("product.L2A_CDU_3"),
          t("product.L2A_CDU_4"),
          t("product.L2A_CDU_5"),
        ],
      },
      {
        title: t("product.L2A_CHILLER"),
        subTitle: t("product.L2A_CHILLER_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A2_front.png",
        thumbnailRight: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A2_back.png",
         details: [
          t("product.L2A_CHILLER_0"),
          t("product.L2A_CHILLER_1"),
          t("product.L2A_CHILLER_2"),
          t("product.L2A_CHILLER_3"),
          t("product.L2A_CHILLER_4"),
          t("product.L2A_CHILLER_5"),
          t("product.L2A_CHILLER_6"),
        ],
      },
    ]
  },

  {
    ref: "RDHx",
    options: [
        {
        title: t("product.RDHx_FIRST"),
        subTitle: t("product.RDHx_FIRST_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/near_door_thumbnail_back.png",
        details: [
          t("product.RDHx_FIRST_0"),
          t("product.RDHx_FIRST_1"),
          t("product.RDHx_FIRST_2"),
          t("product.RDHx_FIRST_3"),
          t("product.RDHx_FIRST_4"),
          t("product.RDHx_FIRST_5"),
          t("product.RDHx_FIRST_6")
        ],
      },
      {
        title: t("product.RDHx_SECOND"),
        subTitle: t("product.RDHx_SECOND_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/near_door_thumbnail_front.png",
        details: [
          t("product.RDHx_SECOND_0"),
          t("product.RDHx_SECOND_1"),
          t("product.RDHx_SECOND_2"),
          t("product.RDHx_SECOND_3"),
          t("product.RDHx_SECOND_4"),
          t("product.RDHx_SECOND_5"),
        ],
      },
    ]
  },
  {
    ref: "others",
    options: [
      {
        title: t("product.OTHERS_FIRST"),
        subTitle: t("product.OTHERS_FIRST_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/others1_single.png",
        thumbnailRight: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/others1_batch.png",
        details: [
          t("product.OTHERS_FIRST_0"),
          t("product.OTHERS_FIRST_1"),
          t("product.OTHERS_FIRST_2"),
          t("product.OTHERS_FIRST_3"),
          t("product.OTHERS_FIRST_4"),
          t("product.OTHERS_FIRST_5"),
          t("product.OTHERS_FIRST_6"),
        ],
      },
      {
        title: t("product.OTHERS_SECOND"),
        subTitle: t("product.OTHERS_SECOND_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/others2.png",
        details: [
          t("product.OTHERS_SECOND_0"),
          t("product.OTHERS_SECOND_1"),
        ],
      },
      {
        title: t("product.OTHERS_THIRD"),
        subTitle: t("product.OTHERS_THIRD_SUB"),
        thumbnailLeft: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/others3.png",
        details: [
          t("product.OTHERS_THIRD_0"),
          t("product.OTHERS_THIRD_1"),
          t("product.OTHERS_THIRD_2"),
        ],
      },
    ]
  }
])

const findIndexInProducts = (productIndex: number, optionIndex: number) => {
  let sum = 0;
  if(productIndex > 0) {
    for(let i = productIndex - 1; i >= 0; i--) {
      sum += products.value[i].options.length
    }
  }
  const flatIndex = sum + optionIndex + 1 % 2;
  return flatIndex % 2 === 0;
}

onMounted(() => {
  const threshold = shrink ? 0.2 : 0.6
  const options = {  
    root: null, // 使用视口作为参考  
    rootMargin: '0px',  
    threshold: [threshold] // 当元素有50%可见时触发  
  };  

  const observer = new IntersectionObserver((entries) => {  
    entries.forEach(entry => {  
      if (entry.isIntersecting) {
        emits("updateProductId", entry.target.id)  
      }
    });  
  }, options); 

  products.value.forEach(product => {
    const element = document.getElementById(product.ref)
    observer.observe(element as HTMLElement)
  })
})
</script>

<style lang="less" scoped>
#product_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8rem;
}
</style>